import {ObjectMeterCheckAssoc} from "../../../model/object-meter-check-assoc";
import {getUseQueryResultData} from "../../../util/selector-util";
import {createSelector} from "@reduxjs/toolkit";

export type ObjectMeterCheckAssocSelectorProps = {};

export const objectMeterCheckAssocSelector = () => createSelector(
  [getUseQueryResultData<ObjectMeterCheckAssoc>],
  (data) => {
    return data ? transformObjectMeterCheckAssoc(data) : undefined;
  }
);

export const objectMeterCheckAssocsSelector = () => createSelector(
  [getUseQueryResultData<ObjectMeterCheckAssoc[]>],
  (data) => {
    return selectObjectMeterCheckAssocsAndTransform(
      data ?? [], {}
    );
  }
);

export const transformObjectMeterCheckAssoc = (value: ObjectMeterCheckAssoc): ObjectMeterCheckAssoc => {
  return {...value}
}

export const selectObjectMeterCheckAssocs = (values?: ObjectMeterCheckAssoc[], selector?: ObjectMeterCheckAssocSelectorProps): ObjectMeterCheckAssoc[] => {
  if (!values) {
    return [];
  }

  return values.filter((v) => {
    let filterIn = true;
    return filterIn;
  });
};

export const selectObjectMeterCheckAssocsAndTransform = (values?: ObjectMeterCheckAssoc[], selector?: ObjectMeterCheckAssocSelectorProps): ObjectMeterCheckAssoc[] => {
  const selected = selectObjectMeterCheckAssocs(values, selector);
  return selected.map(transformObjectMeterCheckAssoc);
};
